const MenuAdmin = [
  {
    heading: "Akongo Animal Welfare Monitor",
  },
  {
    heading: "Ressources",
    translate: "sidebar.heading.RESSOURCES",
  },

  {
    name: "Consulter les questionnaires",
    icon: "fa fa-question-circle",
    path: "QuizzListViewReadOnly",
    translate: "sidebar.nav.QUIZZ_MONITORING",
  },

  {
    name: "Consulter les éthogrammes",
    icon: "fa fa-list",
    path: "obsListViewReadOnly",
    translate: "sidebar.nav.ETHO_MONITORING",
  },

  {
    heading: "Mon compte AWM",
    translate: "sidebar.heading.MY_ACCOUNT",
  },
  {
    name: "Gérer mon compte",
    icon: "fa fa-user-circle",
    translate: "sidebar.nav.USER_SETTINGS",
    path: "userSettings",
  },
]

export default MenuAdmin
